// extracted by mini-css-extract-plugin
export var chevronIcon = "_a1-2";
export var teamName = "_a1-1";
export var teamSwitcherButton = "_a1-0";